// CommissionRecordExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportCommissionRecordExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Commission Records");

  const t = i18n.t.bind(i18n);
 const formatSubscription = (value) => {
  if (!value) return "";
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
  worksheet.columns = [
    { header: t("commissionRecord.columns.id"), key: "id", width: 10 },
    { header: t("commissionRecord.columns.companyName"), key: "companyName", width: 25 },
    { header: t("commissionRecord.columns.subscription"), key: "subscription", width: 20 },
    { header: t("commissionRecord.columns.paymentAmount"), key: "paymentAmount", width: 18 },
    { header: t("commissionRecord.columns.commission"), key: "commission", width: 18 },
    { header: t("commissionRecord.columns.status"), key: "status", width: 15 },
    { header: t("commissionRecord.columns.date"), key: "date", width: 25 },
  ];

  // Add rows
  worksheet.addRows(
    data.map((item, index) => ({
      id: item.id ?? index + 1,
      companyName: item.companyName,
    subscription: Array.isArray(item.subscription)
  ? item.subscription.map(formatSubscription).join(", ")
  : item.subscription
      ? formatSubscription(item.subscription)
      : "-",
      paymentAmount: item.paymentAmount,
      commission: item.commission,
      status: item.status,
      date: item.date,
    }))
  );

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White + Bold
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" }, // Dark blue header
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Export Excel file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "Commission_Records.xlsx");
};

export default ExportCommissionRecordExcel;
